import { AccordionItem, AccordionItemProps } from '@chakra-ui/accordion';
import React from 'react';

export const CmAccordionItem: React.FC<AccordionItemProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <AccordionItem {...rest}>{children}</AccordionItem>;
};
